export default __webpack_public_path__ + "static/media/demonologist_icon.1294ceed.png";